
export const checkUrl = (prod, dev) => {
    let baseURL;
    if(process.env.REACT_APP_ENV === "production"){
        baseURL = prod
    }else {
        baseURL = dev
    }
    return baseURL
}


export const getUrl = (prod, dev, staging) => {
    const env = process.env.REACT_APP_ENV || "development";
    switch (env) {
        case "production":
            return prod;
        case "staging":
            return staging;
        default:
            return dev;
    }
};